import { render, staticRenderFns } from "./taxPaymentList.vue?vue&type=template&id=1b2d411e&scoped=true&"
import script from "./taxPaymentList.vue?vue&type=script&lang=js&"
export * from "./taxPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./taxPaymentList.vue?vue&type=style&index=0&id=1b2d411e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d411e",
  null
  
)

export default component.exports